import { format } from 'date-fns'
import React, { useState } from 'react'

import { useLogisticFilters } from 'hooks/useLogisticFilters'
import { useStores } from 'hooks/useStores'
import { logisticApi } from 'redux/services/logistic'

import { AppLayout } from 'components/AppLayout'
import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { LOGISTIC_STATUS_TEXT } from 'constants/logistic'
import { UserRole } from 'models/user'

import { ReactComponent as UserCircleAddIcon } from 'assets/images/svg/user_circle_add.svg'

import { Filters } from './components/Filters'
import { SelectCurier } from './components/SelectCurier'
import { Statistics } from './components/Statistics'

enum ModalState {
  None,
  Assign,
}
export const FillialsActsPage = () => {
  const { params, setParam, resetParams } = useLogisticFilters()
  const { userStore } = useStores()

  const [modal, setModal] = useState<ModalState>(ModalState.None)
  const [fetch, fetchState] = logisticApi.useLazyGetBranchesActsQuery()
  logisticApi.useGetProjectsQuery()
  // logisticApi.useGetDeliverymensQuery()

  const role = userStore.user?.role as UserRole

  React.useEffect(() => {
    fetch(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.offset])

  const onSubmit = () => {
    fetch(params)
  }
  const reset = () => {
    resetParams()
    fetch(params)
  }
  const openModal = () => {
    setModal(ModalState.Assign)
    document.body.style.overflow = 'hidden'
  }

  const closeModal = () => {
    setModal(ModalState.None)
    document.body.style.overflow = 'auto'
  }

  return (
    <>
      {[UserRole.ControllerUKC, UserRole.Administrator].includes(role) && (
        <AppLayout
          linksRight={[
            {
              title: 'Назначить',
              icon: <UserCircleAddIcon />,
              onClick: openModal,
            },
          ]}
        />
      )}
      <AppLayoutTable
        title="Акты Филлиалов/СК"
        header={<Filters onSubmit={onSubmit} reset={reset} />}
        statistics={<Statistics />}
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              loading={fetchState.isFetching}
              // onClickRow={setSelectedRow}
              dataSource={fetchState.data.results}
              // selected={{
              //   value: selectedRow?.id,
              //   key: 'id',
              // }}
              headers={[
                {
                  data: 'ID Карты',
                  key: 'barcode',
                  width: 50,
                },
                {
                  data: 'Дата',
                  key: 'created_at',
                  render: created_at => {
                    if (created_at) {
                      return format(new Date(created_at), 'yyyy-MM-dd HH:mm')
                    }
                  },
                  width: 50,
                },
                {
                  data: 'Филиал',
                  key: 'filial',
                  render: filial => filial?.name,
                  width: 50,
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, item) =>
                    item.status ? LOGISTIC_STATUS_TEXT[item.status] : '-',
                  width: 50,
                },
                {
                  data: 'Количество карт',
                  key: 'amount',
                  width: 50,
                },
              ]}
            />

            <AppPagination
              forcePage={params.offset! / params.limit!}
              onPageChange={nextPage => {
                setParam('offset', String((nextPage - 1) * params.limit!))
              }}
              count={fetchState.data.count / params.limit!}
            />
          </>
        )}
      </AppLayoutTable>

      {modal === ModalState.Assign && <SelectCurier onClose={closeModal} />}
    </>
  )
}
